import { Text } from '@audio-network/componentlibrary';
import styled from 'styled-components';
import BaseSlider from '../Slider/Slider';
export var WaveformContainer = styled.div.withConfig({
  displayName: "Waveformstyles__WaveformContainer",
  componentId: "sc-5t0ajw-0"
})(["display:grid;grid-area:wave;width:100%;height:0px;grid-template-areas:'waveform waveform waveform';grid-template-rows:1fr;grid-template-columns:auto 1fr auto;align-items:center;justify-content:center;", "{height:2.5rem;max-width:72rem;gap:0.5rem;grid-template-areas:'time waveform duration';grid-template-columns:auto 1fr auto;grid-template-rows:auto;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var Time = styled(Text).withConfig({
  displayName: "Waveformstyles__Time",
  componentId: "sc-5t0ajw-1"
})(["grid-area:time;font-variant-numeric:tabular-nums;padding-right:1rem;display:none;", "{display:block;padding-right:0;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var Waveform = styled.div.withConfig({
  displayName: "Waveformstyles__Waveform",
  componentId: "sc-5t0ajw-2"
})(["grid-area:waveform;position:relative;height:100%;top:-10px;margin:0 -1rem;", "{margin:0;top:0;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var Duration = styled(Text).withConfig({
  displayName: "Waveformstyles__Duration",
  componentId: "sc-5t0ajw-3"
})(["grid-area:duration;font-variant-numeric:tabular-nums;display:none;", "{display:block;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var WaveformImage = styled.img.withConfig({
  displayName: "Waveformstyles__WaveformImage",
  componentId: "sc-5t0ajw-4"
})(["display:", ";height:100%;image-rendering:pixelated;inset:0;width:100%;"], function (_ref) {
  var src = _ref.src;
  return src ? 'initial' : 'none';
});
export var WaveWrapper = styled.div.withConfig({
  displayName: "Waveformstyles__WaveWrapper",
  componentId: "sc-5t0ajw-5"
})(["display:none;", "{position:absolute;width:100%;display:block;height:2.5rem;", "{filter:brightness(1.07);", " [data-anw-music-app].anwThemeDark &{filter:brightness(94%) invert(100%);", "}@media (prefers-color-scheme:dark){[data-anw-music-app]:not(.anwThemeLight) &{filter:brightness(94%) invert(100%);", "}}}}"], function (props) {
  return props.theme.breakpoints.tablet;
}, WaveformImage, function (props) {
  return props.isSoundEffect && "\n\t\t\t\tfilter: opacity(0.1);\n\t\t\t";
}, function (props) {
  return props.isSoundEffect && "\n\t\t\t\tfilter: invert(0.2) !important;\n\t\t\t";
}, function (props) {
  return props.isSoundEffect && "\n\t\t\t\tfilter: invert(0.2) !important;\n\t\t\t";
});
export var PlaybackWaveWrapper = styled(WaveWrapper).withConfig({
  displayName: "Waveformstyles__PlaybackWaveWrapper",
  componentId: "sc-5t0ajw-6"
})(["clip-path:inset(0 100% 0 0);position:absolute;", "{filter:brightness(1.07) hue-rotate(339deg);[data-anw-music-app].anwThemeDark &{filter:brightness(94%) invert(100%) sepia(100%) saturate(0%);", "}@media (prefers-color-scheme:dark){[data-anw-music-app]:not(.anwThemeLight) &{filter:brightness(94%) invert(100%) sepia(100%) saturate(0%);", "}}}"], WaveformImage, function (props) {
  return props.isSoundEffect && "\n\t\t\t\tfilter: invert(0.4) !important;\n\t\t\t";
}, function (props) {
  return props.isSoundEffect && "\n\t\t\t\tfilter: invert(0.4) !important;\n\t\t\t";
});
export var Slider = styled(BaseSlider).withConfig({
  displayName: "Waveformstyles__Slider",
  componentId: "sc-5t0ajw-7"
})(["display:block;width:100%;cursor:pointer;border-radius:0px;", "{&&&{appearance:none;background-color:transparent;background-image:none;position:absolute;top:1.25rem;&::-webkit-slider-thumb{opacity:0;}&::-moz-range-thumb{opacity:0;}&::slider-thumb{opacity:0;}}}"], function (props) {
  return props.theme.breakpoints.tablet;
});